module.exports = __webpack_public_path__ + "static/google-specialist-badge-cfcbd75d46092d8512572eabc4e29df8.png";